  export interface TransactionFiltersDTO {
    status?: string | null;
    startDate?: string;
    endDate?: string;
    page?: number;
    limit?: number;
    customer_id?: string;
  }

  export interface TransactionsDto {
    id: string;
    trans_code: string;
    referenceId: string;
    amount: string;
    customer_msisdn: string;
    customer_name: string;
    customer_email: string;
    status: TransactionStatusEnum;
    commission: number;
    currency: string;
    countryCode: string;
    paymentMethod: any;
    callback_url: string;
    createdAt: string;
    updatedAt: string;
    balance: number;
    externalTransactionId: any;
    subscription?: {
      id: string;
      partnerService?: {
        id: string;
        service?: {
          id: string;
          name: string;
          description: string;
        };
      };
    };
  }

  // WithdrawalDTO.ts

  export interface WithdrawalDTO {
    id?: string;
    amount: string; 
    status: TransactionStatusEnum; 
    adminNotes: string | null;
    externalTransactionId: string | null;
    paymentMethod: string | null;
    fee: string | null;
    eventLog: any; 
    createdAt: string;
    updatedAt: string;
    customer:any
    user:any 
    currency:string
  }

  export enum TransactionStatusEnum {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
    approved="approved",
    rejected="rejected"
  }

  export enum PaymentLinkStatusEnum {
    INITIATED = "INITIATED",
    PENDING = "PENDING",
    SUCCESS = "SUCCESS",
    FAILED = "FAILED",
  }

  export interface Notifications {
    id?: string ;
    message?: string;
    isRead?: boolean;
    createdAt:string
  }

  export interface QueryParamsDTO {
  page?: number;
  limit?: number;
  search?: string;
  sortBy?: "code" | "detail" | "createdAt" | "updatedAt";
  type?: string;
}